import { combineReducers } from 'redux';

import rates from './rates/reducer';

export default combineReducers({
  rates,
});



// WEBPACK FOOTER //
// ./src/pages/reimbursementrates/state/reducer.js